import { render, staticRenderFns } from "./goods-in-review.vue?vue&type=template&id=3afff18a&"
import script from "./goods-in-review.vue?vue&type=script&lang=js&"
export * from "./goods-in-review.vue?vue&type=script&lang=js&"
import style0 from "./goods-in-review.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports